import React, { useEffect, useState } from "react";
import "./Login.style.css";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Authenticator } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export const Login: React.FC = () => {
  const { route, user } = useAuthenticator((context) => [context.route]);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    I18n.putVocabulariesForLanguage("pt", {
      "Sign In": "Entrar",
      "Sign in": "Entrar",
      "Signing in": "Entrando",
      "Sign in to your account": "Bem-vindo de volta!",
      "Change Password": "Redefinir Senha",
      "Changing Password": "Redefinindo Senha",
      Username: "E-mail",
      Password: "Senha",
      "Confirm Password": "Confirmar Senha",
      ConfirmPassword: "Confirmar Senha",
      "Forgot your password?": "Esqueceu sua senha?",
      "Reset Password": "Redefinir senha",
      "Enter your Email": "Insira seu e-mail",
      "Enter your Password": "Insira sua senha",
      "Please confirm your Password": "Por favor confirme sua senha",
      "Send code": "Enviar código",
      "New password": "Nova senha",
      "Confirm new password": "Confirmar nova senha",
      "Change password": "Alterar senha",
      "Back to Sign In": "Voltar para entrar",
      "Account recovery requires verified contact information":
        "A recuperação da conta requer informações de contato verificadas",
      Skip: "Pular",
      Submit: "Enviar",
      ChangePassword: "Redefinir Senha",
      "Enter your email": "Insira seu email",
      Code: "Código",
      "Code *": "Código",
      "New Password": "Nova Senha",
      Changing: "Modificando",
      Submitting: "Enviando",
      Verify: "Verificar",
      Verifying: "Verificando",
    });

    setTimeout(() => {
      document
        .querySelectorAll<HTMLInputElement>("input[name='username']")
        .forEach((el) => {
          el.placeholder = "Digite seu e-mail";
          el.style.textAlign = "left";
        });

      document
        .querySelectorAll<HTMLInputElement>("input[name='password']")
        .forEach((el) => {
          el.placeholder = "Digite sua senha";
          el.style.textAlign = "left";
        });
    }, 5);
  }, []);

  useEffect(() => {
    if (route === "authenticated") {
      navigate(RoutesConfig.HOME.path);
    }
  }, [route, user]);

  const handleBack = () => {
    navigate(RoutesConfig.SPLASH.path);
  };

  return (
    <>
      <div className="split-screen">
        <div className="bg-image"></div>
        <div className="left-side">
          <img
            src="/fundoLogin.png"
            alt="Login Illustration"
            className="image"
          />
        </div>
        <div className="right-side">
          <Box
            display="flex"
            flexDirection="column"
            gap={4}
            sx={{
              backgroundColor: isMobile ? "white" : "transparent",
              borderRadius: isMobile ? "17px" : 0,
            }}
          >
            <IconButton
              onClick={handleBack}
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                zIndex: 1,
              }}
            >
              <ArrowBackIosNewIcon
                style={{ color: isMobile ? "white" : "#0A0C33" }}
              />
            </IconButton>

            {route !== "forgotPassword" && (
              <img
                src="/braxcomTrackingLogo.png"
                style={{
                  width: "100%",
                  padding: isMobile ? "10px" : 0,
                  marginTop: isMobile ? "20px" : 0,
                }}
              />
            )}
            <div style={{ width: "100%" }}>
              <Authenticator hideSignUp></Authenticator>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
};
